export default "__VITE_PUBLIC_ASSET__d298ffa3__"